const RightArrow = ({ fillColor, ...props }: any) => (
	<svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M9.3 1.2998L7.9 2.6998L12.2 6.9998H0V8.9998H12.2L7.9 13.2998L9.3 14.6998L16 7.9998L9.3 1.2998Z"
			fill={fillColor || "white"}
		/>
	</svg>
);
export default RightArrow;
